// extracted by mini-css-extract-plugin
module.exports = {"section":"_3El6U","backgroundImage":"_1wPId","wrapperImage":"_3w_MK","image":"FRoui"};